<div
  class="filter-sticky-stack"
  #filterStickyStack>
  <div class="filter-header">
    <div class="tabs compact">
      <nav
        mat-tab-nav-bar
        class="themed-tab-nav">
        <a
          mat-tab-link
          *ngFor="let tab of tabs"
          (click)="enableState(tab.value, $event)"
          (touchstart)="enableState(tab.value, $event)"
          [active]="(tabParam$ | async) == tab.value"
          [attr.data-cy]="
            'state-' + tab.value.toLowerCase() + '-toggle-button'
          ">
          <mat-icon
            [svgIcon]="tab.svgIcon"
            class="size-20"></mat-icon>
          {{ tab.label | i18n | titlecase }}
        </a>
      </nav>
    </div>
    <div class="filter-actions">
      <button
        mat-stroked-button
        class="filter-button"
        [class.collapsed]="filtersCollapsed"
        (click)="toggleFilters()"
        data-cy="pooler-jobs-index-collapse-filter-button"
        type="button">
        <div class="filter-button-content">
          <mat-icon svgIcon="filter_alt_outline"></mat-icon>
          <span class="mat-fab__label">{{
            ("filter" | i18n) || "Filter"
          }}</span>
        </div>
      </button>

      <app-tab-toggle
        (click)="toggleView()"
        class="jobs-view-toggle">
        <app-tab-toggle-option
          [active]="activeView === 'tiles'"
          data-cy="jobs-view-toggle-tiles">
          <mat-icon
            svgIcon="tiles"
            size="20"
            class="toggle-icon"></mat-icon>
          {{ ("tiles" | i18n) || "Kacheln" }}
        </app-tab-toggle-option>
        <app-tab-toggle-option
          [active]="activeView === 'list'"
          data-cy="jobs-view-toggle-list">
          <mat-icon
            svgIcon="jobs-list"
            size="20"
            class="toggle-icon"></mat-icon>
          {{ ("list" | i18n) || "Liste" }}
        </app-tab-toggle-option>
      </app-tab-toggle>
    </div>
  </div>
  <div
    class="collapse-wrapper collapse-filter"
    [class.collapsed]="filtersCollapsed"
    [class.expanded]="!filtersCollapsed"
    (transitionend)="onFilterCollapseTransitionEnd($event)">
    <div class="collapse-child">
      <div class="row filter-bar">
        <div class="col-md-12">
          <app-date-range-select
            *ngIf="user"
            [useQueryParam]="'range'"
            [chips]="dateRangeChips"
            [selectedRange]="selectedRange"
            (dateRangeChanged)="filterByDateRange()"
            data-cy="date-range-select"></app-date-range-select>
        </div>
        <div class="col-md-12">
          <div class="jobs-index__department-select-row">
            <app-department-select
              [isMultiSelect]="true"
              [multiSelectVariant]="'select'"
              [lightFormField]="true"
              [selectedDepartmentIds]="(selectedDepartmentIds$ | async) || []"
              (departmentsSelectionChanged)="selectDepartments($event)"
              data-cy="jobs-index-department-select"></app-department-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="jobs-index__search-row">
            <mat-form-field class="search-input light-form-field">
              <mat-label>{{
                ("search" | i18n) || "Suchen..." | titlecase
              }}</mat-label>
              <input
                matInput
                [ngModel]="searchParam$ | async"
                (ngModelChange)="searchByText($event)"
                name="searchText"
                data-cy="job-search-input" />
              <button
                mat-button
                matSuffix
                mat-icon-button
                aria-label="Search"
                (click)="$event.stopPropagation()">
                <mat-icon svgIcon="magnify"></mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="jobs-index__filter-row">
            <div class="flex-spacer"></div>
            <div class="filter-action-buttons">
              <button
                mat-button
                class="save-filter-button"
                (click)="saveDefaultFilter()"
                data-cy="save-filter-button">
                <div class="filter-actions-button-content">
                  <mat-icon
                    svgIcon="save"
                    size></mat-icon>
                  {{ ("saveDefaultFilter" | i18n) || "Filter speichern" }}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="jobs-list"
  *ngIf="jobsByDateMap$ | async as jobsByDateMap">
  <div
    *ngIf="daysList.length"
    class="jobs-index-sideline-container"
    [class.is-compact]="activeView === 'list'">
    <div class="jobs-index-sideline-start"></div>
    <div class="jobs-index-sideline"></div>
    <div class="jobs-index-sideline-end"></div>
  </div>
  <ng-container
    *ngIf="
      ($isLoadingJobs | async) &&
      !(jobs$ | async)?.length &&
      activeView !== 'list'
    ">
    <p>{{ "loadingJobs" | i18n }}</p>
    <mat-spinner
      class="loading-spinner"
      data-cy="loading-jobs-spinner"
      diameter="24"></mat-spinner>
  </ng-container>
  <ng-container
    *ngIf="
      !($isLoadingJobs | async) &&
      !(jobs$ | async)?.length &&
      activeView !== 'list'
    ">
    <p style="height: 100%">
      {{ "noJobsFound" | i18n }}
    </p>
  </ng-container>
  <div
    class="jobs-index-jobs-list"
    [class.list-view]="activeView === 'list'"
    data-cy="jobs-index-jobs-list">
    <div
      class="jobs-index-jobs-list-header"
      *ngIf="($isLoadingJobs | async) || (jobs$ | async)?.length">
      <h1 class="dashboard-title">
        <ng-container *ngIf="tabParam$ | async as tabId">
          <ng-container [ngSwitch]="tabId">
            <span *ngSwitchCase="'OPEN'">{{
              ("requests" | i18n) || "Anfragen"
            }}</span>
            <span *ngSwitchCase="'ANSWERED'">{{
              ("answered" | i18n) || "Beantwortet"
            }}</span>
            <span *ngSwitchCase="'CLOSED'">{{
              ("bookedServices" | i18n) || "Gebuchte Dienste"
            }}</span>
            <span *ngSwitchCase="'ARCHIVED'">{{
              ("archivedServices" | i18n) || "Archivierte Dienste"
            }}</span>
            <span *ngSwitchDefault>{{
              ("requests" | i18n) || "Anfragen"
            }}</span>
          </ng-container>
        </ng-container>
      </h1>
      <ng-container *ngIf="tabParam$ | async as tabId">
        <app-hide-all-jobs-button
          *ngIf="tabId === 'OPEN'"></app-hide-all-jobs-button>
      </ng-container>
    </div>
    <div
      *ngIf="activeView === 'list'"
      class="jobs-list-view-header-row">
      <div
        *ngFor="let column of columns$ | async; trackBy: trackByColumnKey"
        class="job-list-view-header-column"
        [attr.data-column-key]="column.key"
        [class.with-small-spacing]="column.smallSpacing">
        <span>{{ (column.key | i18n) || column.label }}</span>
        <div
          class="column-resize-handle"
          (mousedown)="onResizeStart($event, column.key)"></div>
      </div>
    </div>
    <div
      *ngIf="activeView === 'list'"
      class="jobs-list-view-header-row-bar"></div>
    <ng-container *ngFor="let day of daysList">
      <div
        *ngIf="day.previousDateRangeStart"
        class="jobs-index-previous-date-range">
        <div>
          <span class="day-of-the-week">{{
            day.previousDateRangeStart | date: "EEE"
          }}</span>
          {{ day.previousDateRangeStart | date: "dd.MM.yyyy" }}
          <span class="calendar-week">
            {{ ("calendarWeekShort" | i18n) || "KW" }}
            {{ day.previousDateRangeStart | date: "ww" }}
          </span>
        </div>
        <div
          *ngIf="day.previousDateRangeEnd !== day.previousDateRangeStart"
          class="second-day">
          -
          <span class="day-of-the-week">{{
            day.previousDateRangeEnd | date: "EEE"
          }}</span>
          {{ day.previousDateRangeEnd | date: "dd.MM.yyyy" }}
          <span class="calendar-week">
            {{ ("calendarWeekShort" | i18n) || "KW" }}
            {{ day.previousDateRangeEnd | date: "ww" }}
          </span>
        </div>
      </div>
      <div
        class="jobs-index-day-header"
        [style.--header-height.px]="
          activeView === 'list'
            ? jobsIndexListViewDayHeaderOffsetPx
            : jobsIndexDayHeaderTopPx ?? jobsIndexDayHeaderTopFallbackPx
        "
        [class.is-today]="day.date === today">
        <div class="day-start-circle"></div>
        <div>
          <span class="day-of-the-week">{{ day.date | date: "EEE" }}</span>
          {{ day.date | date: "dd.MM.yyyy" }}
          <span class="calendar-week">
            {{ ("calendarWeekShort" | i18n) || "KW" }}
            {{ day.date | date: "ww" }}
          </span>
        </div>
      </div>
      <div class="jobs-index-jobs-list-items">
        <ng-container *ngIf="jobsByDateMap.get(day.date) as jobs">
          <div *ngFor="let job of jobs; let i = index; trackBy: trackJob">
            <app-pooler-job-list-item
              data-cy="job-list-item"
              [job]="job"
              [compact]="activeView === 'list'"
              [columns]="(columns$ | async) || []"></app-pooler-job-list-item>
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            ($isLoadingJobs | async) &&
            !(jobs$ | async)?.length &&
            activeView === 'list'
          ">
          <p>{{ "loadingJobs" | i18n }}</p>
          <mat-spinner
            class="loading-spinner"
            data-cy="loading-jobs-spinner"
            diameter="24"></mat-spinner>
        </ng-container>
        <ng-container
          *ngIf="
            !($isLoadingJobs | async) &&
            !(jobs$ | async)?.length &&
            activeView === 'list'
          ">
          <p>
            {{ "noJobsFound" | i18n }}
          </p>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
